import 'babel-polyfill'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'

import './bla.css'
import Vue from 'vue'

const perPage = 50;

wp.api.loadPromise.done(async () => {

    Vue.mixin({
        filters: {
            date (timestamp) {
                let d = new Date(timestamp)
                return d.toLocaleDateString()
            },
            datetime (timestamp) {
                let d = new Date(timestamp)
                return d.toLocaleString()
            },
        },
    })

    new Vue({
        components: { flatPickr },
        data () {
            return {
                collection: null,
                items: [],
                params: {},
                loading: true,
                fpConfig: {
                    onChange: this.update_filters,
                    dateFormat: "m/d/Y",
                },
            }
        },
        computed: {
            pageArray () {
                let pages = Array(this.collection.state.totalPages).fill(1)
                return pages.map((item, index) => index + 1)
            },
        },
        methods: {
            isodate (usdate) {
                let parts = usdate.split('/')
                parts.unshift(parts.pop())
                return parts.join('-')
            },
            previous () {
                let p = this.collection.state.currentPage - 1;
                if (p > 0) {
                    this.get_page(p)
                }

                window.scrollTo(0, 0)
            },
            next () {
                let p = this.collection.state.currentPage + 1;
                if (p <= this.collection.state.totalPages) {
                    this.get_page(p)
                }

                window.scrollTo(0, 0)
            },
            update_filters () {
                this.get_page(1)
            },
            update_search: _.debounce(async function () { 
                    await this.get_page(1)
                }, 400),

            async get_page (page_num, is_link=false) {
                let filters = {
                }
                if (this.params.start_date) {
                    filters.after = this.isodate(this.params.start_date) + 'T00:00:00'
                }
                if (this.params.end_date) {
                    filters.before = this.isodate(this.params.end_date) + 'T11:59:59'
                }
                if (!!this.params.search) {
                    filters.search = this.params.search
                }

                if (is_link) {
                    window.scrollTo(0, 0)
                }
                this.items = await this.collection.fetch({
                    data: {
                        page: page_num,
                        per_page: perPage,
                        status: ['publish', 'future'],
                        ...filters,
                    }
                })

            },
            
            get_year (year) {
                this.params.start_date = `01/01/${year}`
                this.params.end_date = `12/31/${year}`
                this.update_filters()
            },
        },
        async created () {
            this.collection = new wp.api.collections.Legislation()
            this.items = await this.collection.fetch({
                data: {
                    per_page: perPage,
                    status: ['publish', 'future'],
                }
            })
            this.$nextTick(_ => this.loading = false)
        },
        async mounted () {
        }
    }).$mount('#bla-app')
})



// WEBPACK FOOTER //
// ./src/main.js